import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "draft-a-report-from-an-investigation",
  courseId: "investigations",
  order: 11,
  title: "Draft a report",
  subtitle: "From an investigation",
  summary:
    "When the investigation has to become a document, Draft Report turns the Brief, confirmed leads, and call summaries into a case report draft in the regular editor, using your template and instructions.",
  learn: [
    "Start a report draft from the Export menu",
    "Add instructions and pick a template",
    "Use an investigation as context for a normal case",
  ],
  minutes: 3,
  releasedAt: "2026-08-24T00:00:00.000Z",
  gate: "investigations",
  body: [
    {
      type: "paragraph",
      text: "Draft Report hands the editor the case as the AI currently understands it, then the usual report tools take over.",
    },
    {
      type: "steps",
      items: [
        "Click **Export** in the header and choose Draft Report.",
        "In the dialog, add any instructions for the writer (\"supplemental covering calls from October only\").",
        "Choose a report template if you want one.",
        "Submit. A new case appears in **Cases** with a \"Drafting Investigation Report\" screen while it writes.",
        "Open the case when it finishes.",
      ],
    },
    {
      type: "paragraph",
      text: "The result is a normal report. Edit it, score it, check statutes, and export it like any other.",
    },
    {
      type: "callout",
      tone: "note",
      title: "What goes in",
      text: "The current Brief, confirmed leads (open leads are counted but flagged as unverified), call summaries, document summaries, and the entity list. Dismissed leads are left out.",
    },
    {
      type: "callout",
      tone: "tip",
      title: "The other direction",
      text: "When you write an ordinary report, the upload modal's **Report Settings** has an **Investigation Context** dropdown. Pick an investigation and the AI gets its known names and places so it resolves \"Marcus\" correctly, without importing the investigation's findings into your narrative.",
    },
    {
      type: "paragraph",
      text: "If you want a package for the prosecutor instead of a narrative, see Export and discovery.",
    },
  ],
  related: ["export-and-discovery", "report-templates", "read-the-brief"],
};

export default lesson;
